<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <button id="openFunds" style="display: none" (click)="openAddFunds()"></button>
  <button id="openPayout" style="display: none" (click)="openPayout()"></button>
</ion-app>
